import React from 'react';
import T from 'prop-types';
// redux
import { connect } from 'react-redux';
import { openModal } from '../../../redux/reducers/modal';
// components
import Icon from '../../../components/Icon/Icon';
// utils
import daysDiff from '../../../utils/daysDiff';
// shapes
import userShape from '../../../shapes/user';
// styles
import styles from './RecoveryClock.mod.css';
import classnames from 'classnames/bind';

const cx = classnames.bind(styles);

const RecoveryClock = ({ user, openModal, recoveryTitle, recoveryTime }) => {
  const isClient = user.role === 'client';
  const userData = isClient ? user : user.client_person;
  const userColor = userData.profile_color || '#7fe7ab';
  const { clocks } = userData.progress;
  let daysInRecovery = daysDiff(clocks.last_attempt_start || clocks.start);
  if (isNaN(daysInRecovery)) daysInRecovery = 0;
  const title =
    recoveryTitle ||
    `${daysInRecovery} ${daysInRecovery === 1 ? 'day' : 'days'}`;
  const iconType = isClient ? 'recovery' : 'clock';

  const handleClick = () => {
    isClient && openModal('RESET_CLOCK', { userColor });
  };

  return (
    <div
      className={cx('recovery-wrapper', {
        client: isClient,
      })}
    >
      <div
        className={cx('recovery-container', {
          'hint--bottom': isClient,
          'recovery-time': recoveryTime,
        })}
        data-hint="Reset your recovery clock"
        onClick={handleClick}
      >
        <Icon
          className={cx('reset-recovery', {
            rotatable: isClient,
            'reset-recovery-time': recoveryTime,
          })}
          type={iconType}
          style={{ backgroundColor: userColor }}
        />
        <span style={{ color: userColor }}>{title}</span>
      </div>
    </div>
  );
};

RecoveryClock.propTypes = {
  user: userShape,
  openModal: T.func,
  recoveryTitle: T.string,
  recoveryTime: T.bool,
};

export default connect(
  state => ({
    user: state.auth.user,
  }),
  { openModal }
)(RecoveryClock);



// WEBPACK FOOTER //
// ./src/containers/RecoveryPlan/components/RecoveryClock.jsx